import React from 'react';
import { TileLayer, WMSTileLayer } from 'react-leaflet';
import { LAYERS, WMS_BASE } from '../services/wfsClient';

const TILE_DEFAULTS = { maxZoom: 22, minZoom: 2, noWrap: true, updateWhenIdle: true, keepBuffer: 0, opacity: 0.6, zIndex: 1 };

const BASE_MAPS = {
    osm: { className: 'osm-tiles', attribution: '&copy; OpenStreetMap', url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', maxNativeZoom: 19, bounds: [[-90, -180], [90, 180]] },
    topo: { attribution: '&copy; OpenTopoMap', url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', maxNativeZoom: 17 },
    satellite: { attribution: '&copy; Esri', url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}' },
    'google-road': { attribution: '&copy; Google', url: 'https://mt0.google.com/vt/lyrs=m&hl=es&x={x}&y={y}&z={z}' },
    'google-satellite': { attribution: '&copy; Google', url: 'https://mt0.google.com/vt/lyrs=s&hl=es&x={x}&y={y}&z={z}' },
    'google-hybrid': { attribution: '&copy; Google', url: 'https://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}' },
};

/* Capas WMS según el nombre que muestra el control de capas */
const INFO_LAYERS = { Parcelario: LAYERS.parcelas, 'Límites': LAYERS.limites, Comercios: LAYERS.comercios };

const LABELS_ENV = {
    on: 'LABEL_FOLLOW_LINE:false;LABEL_MAX_DISPLACEMENT:0;LABEL_PRIORITY:1000;LABEL_WRAP_LIMIT:60;LABEL_SPACE_AROUND:50;LABEL_ANCHOR_POINT:0.5 0.5;LABEL_PADDING:0;PARTIALS:false',
    off: 'LABEL_FOLLOW_LINE:false;LABEL_MAX_DISPLACEMENT:0;LABEL_PRIORITY:1000;LABEL_WRAP_LIMIT:60;LABEL_SPACE_AROUND:5;LABEL_ANCHOR_POINT:0.5 0.5;LABEL_PADDING:0;LABEL_SHOW:false',
};

/* MapLayers: mapa base elegido + capas de información del municipio */
function MapLayers({ baseMap, layersVisible, labelsOn }) {
    const baseLayer = BASE_MAPS[baseMap];
    // Una sola petición WMS para todas las capas visibles
    const infoLayers = Object.keys(INFO_LAYERS).filter(name => layersVisible[name]).map(name => INFO_LAYERS[name]);

    return (
        <>
            {baseLayer && <TileLayer key={baseMap} {...TILE_DEFAULTS} {...baseLayer} />}

            {infoLayers.length > 0 && (
                <WMSTileLayer
                    key={infoLayers.join(',')}
                    zIndex={10}
                    url={WMS_BASE}
                    params={{
                        layers: infoLayers.join(','),
                        format: 'image/png',
                        transparent: true,
                        tiled: true,
                        format_options: 'antialias:true',
                        buffer: 0,
                        tileSize: 256,
                        env: labelsOn ? LABELS_ENV.on : LABELS_ENV.off,
                    }}
                    version="1.1.1"
                    tileSize={256}
                    updateWhenIdle={true}
                    keepBuffer={2}
                    maxZoom={22}
                    opacity={1}
                />
            )}
        </>
    );
}

export default MapLayers;
